import type { IconSvgObject } from './types';

const ShuffleSquareIcon: IconSvgObject = [
  ["path", { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 17.5L17.5 15.5H14.9806C14.6768 15.5 14.3895 15.3619 14.1998 15.1247L8.80024 8.3753C8.61047 8.13809 8.32316 8 8.01938 8H6.5M16 6.5L17.5 8.5H14.9142C14.649 8.5 14.3946 8.60536 14.2071 8.79289L13.5 9.5M6.5 16H8.08579C8.351 16 8.60536 15.8946 8.79289 15.7071L10 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ShuffleSquareIcon;
